import NextLink from 'next/link'
import Image, { ImageProps } from 'next/image'

import { twMerge } from 'src/libs/tailwind-css'

import {
    CONTENT_CONTAINER_STYLES,
    HEADING_4_STYLES,
    HEADING_5_STYLES,
    PARAGRAPH_STYLES,
    CAPTION_STYLES,
} from '../design-system'

interface TextSectionProps {
    children: React.ReactNode
}

export function TextSection(props: TextSectionProps) {
    return <div {...props} className={twMerge(CONTENT_CONTAINER_STYLES, 'max-w-lg')} />
}

interface ParagraphProps {
    children: React.ReactNode
}

export function Paragraph(props: ParagraphProps) {
    return <p {...props} className={twMerge(PARAGRAPH_STYLES, 'mt-[1.2rem]')} />
}

interface HeadingProps {
    children: React.ReactNode
}

export function Heading2(props: HeadingProps) {
    // eslint-disable-next-line jsx-a11y/heading-has-content
    return <h2 {...props} className={twMerge(HEADING_4_STYLES, 'w-[90%] mt-16 mb-6')} />
}

export function Heading3(props: HeadingProps) {
    // eslint-disable-next-line jsx-a11y/heading-has-content
    return <h3 {...props} className={twMerge(HEADING_5_STYLES, 'w-[90%] mt-12 mb-6')} />
}

interface LinkProps extends Pick<React.ComponentPropsWithoutRef<'a'>, 'target' | 'children'> {
    href: string
}

export function Link({ href, ...props }: LinkProps) {
    return (
        <NextLink href={href}>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a {...props} className="underline transition-colors hover:text-grey-700/60" />
        </NextLink>
    )
}

export function OrderedList(
    props: Pick<React.ComponentPropsWithoutRef<'ol'>, 'children' | 'className' | 'start' | 'type'>
) {
    return <ol {...props} className={twMerge('mt-[1.2rem] list-decimal pl-7', props.className)} />
}

interface ListItemProps {
    children: React.ReactNode
}

export function ListItem(props: ListItemProps) {
    return <li {...props} className="mt-[1.2rem]" />
}

interface ImageWithCaptionProps extends ImageProps {
    caption?: string
    alt: string
}
export function ImageWithCaption({ caption, alt, className, ...imgProps }: ImageWithCaptionProps) {
    return (
        <figure className={twMerge('my-10', className)}>
            <div className="grid justify-items-center grid-cols-1">
                <Image alt={alt || caption} {...imgProps} />
            </div>
            {caption && (
                <figcaption
                    className={twMerge(CAPTION_STYLES, 'text-grey-700/60 mt-4 text-center')}
                >
                    {caption}
                </figcaption>
            )}
        </figure>
    )
}
